/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_646cdaea"]'><cube-divider position="left"><div :class='["divider-slot"]'>This is slot text</div></cube-divider></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_646cdaea"}'>
.divider-slot
  color #fc9153
  font-size 12px
  padding-left 10px
  padding-right 10px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_646cdaea"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_646cdaea"}
  /** script content **/
  require("./divider-slot.mpx.js?isComponent&outputPath=components%2Fdivider-slot646cdaea%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./divider-slot.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fdivider-slot646cdaea%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_646cdaea"],
    ctorType: "component",
    outputPath: "components/divider-slot646cdaea/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-divider':getComponent(require("../../../packages/mpx-cube-ui/src/components/divider/index.mpx?isComponent&outputPath=components%2Findex731ea706%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>